import React from 'react';
import FieldInput from '../Input';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        columnGap: 12,
        justifyContent: 'space-between'
    },
    label: {
        color: '#FFF',
        fontFamily: 'Calibri, sans-serif'
    },
    datePicker: {
        display: 'flex',
        alignItems: 'center',
    },
    mdash: {
        color: '#fff'
    }
}));

const FieldsDatePicker = ({
    register,
    label,
    isPeriod = true,
    type = "datetime-local"
}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div>
                <span className={classes.label}>{label}</span>
            </div>
            <div className={classes.datePicker}>
                <FieldInput
                    name="from_date"
                    type={type}
                    register={register}
                />
                {
                    isPeriod && (
                        <>
                            <span className={classes.mdash}>&nbsp;&mdash;&nbsp;</span>
                            <FieldInput
                                name="to_date"
                                type={type}
                                register={register}
                            />
                        </>
                    )
                }
            </div>
        </div>
    )
}

export default FieldsDatePicker;